import { combineReducers } from "redux";
import result from "./resultReducer"



const rootReducer = combineReducers({
    result
});
export default rootReducer;
